import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'zh', // 默认语言
  fallbackLocale: 'en', // 回退语言
});

// 监听语言切换事件
i18n.onLanguageSwitched = (oldLang, newLang) => {
  // 切换语言时重新加载 Vuex 模块的内容
  Vue.prototype.$store.dispatch('loadAllModulesContent');
};

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js